import { StatisticsCountsMapper } from './counts';
import { StatisticsByDatesMapper } from './by-dates';
import { StatisticsAppointments } from './appointments';

export class StatisticsMapper {
  public static Counts = StatisticsCountsMapper;
  public static ByDates = StatisticsByDatesMapper;
  public static Appointments = StatisticsAppointments;
}
